/* eslint-disable no-useless-catch */
import { serialize } from '../utils';
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/entity-certifications';

export const EntityCertificationApi = {
  filter: async (option: any) => {
    let url = `${pathname}/filter`;
    const query = serialize(option);
    url += query;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  filterAll: async () => {
    const url = `${pathname}/filter-all`;

    try {
      const response = await entityService.get(url);

      return response;
    } catch (error) {
      throw error;
    }
  },

  create: async (body: any) => {
    const url = pathname;

    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  createMulti: async (body: CreateMultiEntityCertification) => {
    const url = `${pathname}/multi`;

    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  remove: async (id: string) => {
    try {
      const response = await entityService.delete(`${pathname}/${id}`);
      return response;
    } catch (error) {
      throw error;
    }
  },

  removeMulti: async (body: RemoveMultiEntityCertification) => {
    const url = `${pathname}/delete/multi`;
    try {
      const response = await entityService.post(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  update: async (params: UpdateEntityCertification) => {
    const { id, body } = params;

    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export interface UpdateEntityCertification {
  id: string;
  option: {
    targetType: string;
  };
  body: any;
}

export interface CreateMultiEntityCertification {
  entityCertifications: { entityID: string; certificationID: string }[];
}

export interface RemoveMultiEntityCertification {
  entityCertificationIDs: string[];
}
